/** The Merx mark from the v2 prototype: an M in a rounded square with a cyan dot. */
export function Mark({ size = 24 }: { size?: number }) {
  return (
    <svg viewBox="0 0 20 20" width={size} height={size} aria-hidden="true" className="shrink-0">
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <polyline
        points="5.5,13.5 5.5,7.5 8.7,11.1 11.7,7.5 11.7,13.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx="15" cy="6" r="2.4" fill="#22BCE8" />
    </svg>
  );
}
